import { FlexView, TextPreset } from '@facile-it/full-metal-ui/components'
import * as React from 'react'
import { Icon } from '..'
import * as styles from './DownloadableDocument.css'

export interface DownloadableDocumentProps {
    href: string
    title: string
}

export const DownloadableDocument: React.FC<DownloadableDocumentProps> = ({ href, title }) => (
    <FlexView.Container alignItems="center">
        <Icon variant="pdf" alt="pdf" />
        <TextPreset
            className={styles.doc}
            preset="paragraph-xl"
            component="a"
            href={href}
            target="_blank"
            paddingLeft="xs"
        >
            {title}
        </TextPreset>
    </FlexView.Container>
)
